module.exports = __webpack_public_path__ + "img/icon_map_dian_zaixian1.80767402.svg";